import React, { useState } from "react";
import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddCrossModal from "../AddCrossModal/AddCrossModal";
import { useNavigate } from "react-router-dom";

const HeaderSection = ({ tabIndex, handleTabChange }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);
  const navigate = useNavigate();
  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        mb={3}
      >
        {/* Заголовок */}
        <Typography variant="h6" fontWeight={600}>
          Скрипти та характеристики
        </Typography>

        {/* Центр — табы */}
        <Box flexGrow={1} display="flex" justifyContent="center">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              minHeight: "auto",
              "& .MuiTab-root": {
                minHeight: "36px",
                minWidth: "100px",
                textTransform: "none",
                borderRadius: "8px",
                px: 2,
                py: 1,
                mx: 0.5,
                fontWeight: 500,
              },
              "& .Mui-selected": {
                backgroundColor: "primary.text",
                color: "#fff",
              },
            }}
          >
            {" "}
            <Tab label="Основні" disableRipple />
            <Tab label="Крос товари" disableRipple />
          </Tabs>
        </Box>

        {/* Кнопка справа */}
        {tabIndex === 0 ? (
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{
              color: "primary.main",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: 2,
            }}
            onClick={() => navigate("/management/add-script")}
          >
            Додати товар
          </Button>
        ) : (
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{
              color: "primary.main",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: 2,
            }}
            onClick={handleOpen}
          >
            Додати крос
          </Button>
        )}
      </Box>

      {/* Здесь подключаем новый модал */}
      <AddCrossModal openModal={openModal} handleClose={handleClose} />
    </>
  );
};

export default HeaderSection;
